module.exports = __webpack_public_path__ + "img/41.031aaf4f.png";